import React, { useContext, useEffect, useRef, useState} from "react";
import { IonGrid, IonRow, IonCol, IonButton, IonModal, IonInput, IonLabel, IonContent, IonText, IonHeader } from '@ionic/react';

import '../../../css/layout.css';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


export function UpdatePayMethod (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let paymentMethod_momoRef = useRef();

    let bankAccountName = useRef();
    let bankAccountNumber = useRef();
    let routingNumber = useRef();
    let bankName = useRef();
    let branchName = useRef();

    function retrievePaymentMethods()
    {

        alert("In retrieve Payment Methods");
        
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '00_paymentMethods_retrieve',
                user: acctID,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');
            let cols = rows[0].split('|');

            paymentMethod_momoRef.current.value = cols[0];
        })
        .catch(error => {
            console.error(error);
        })

    }

    function handleSavePaymentMethod_checking() {

        const requestOptions = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
             },
            body: JSON.stringify({
                Tracker: props.tracker,
                user: props.acctID,
                //merchantSchema: schema,
                uEnterBankAcctName: bankAccountName.current.value,
                uEnterAcctNumber: bankAccountNumber.current.value,
                uEnterRoutingNumber: routingNumber.current.value,
                uEnterBankName: bankName.current.value,
                uEnterBankBranch: branchName.current.value,

            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {
            
            alert("Payment Method - Checking Updated.");
            alert(res);

       })
    }

    function saveMTNMomo()
    {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '00_paymentMethod_mtn',
                user: acctID,
                xPaymentMethod_mtn: paymentMethod_momoRef.current.value,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            retrievePaymentMethods();


        })
        .catch(error => {
            console.error(error);
        })
    }

    function closeModalHandler(event) {

        //alert('Inside closeModalHandler');
        props.closeModal(event);
    }

    useEffect(() => {

        retrievePaymentMethods();
        
    }, [])

    return (
                <IonModal isOpen={ props.openModal }>
                    <IonHeader style={{color: 'black'}}>
                        <IonGrid>
                            <IonRow>
                                <IonCol>
                                    <h3>UPDATE PAYMENT METHODS</h3>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    <IonContent className='grid_content'>
                        <IonGrid >
                        <IonRow>
                            <h5>MTN MOMO</h5>
                        </IonRow>
                        <IonRow>
                            <IonCol size="6">
                                <IonText>PHONE NUMBER</IonText>
                            </IonCol>
                            <IonCol size="6">
                                <IonInput className='professional-input' type='text' ref={ paymentMethod_momoRef }  placeholder='Enter MTN MOMO' autocomplete='off' required></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={() => saveMTNMomo()}>SAVE</IonButton>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <h5>CHECKING</h5>
                        </IonRow>
                        <IonRow>
                                <IonCol>
                                    <IonLabel>Account Name: </IonLabel>
                                    <IonInput placeholder='Enter Bank Account Name' ref={bankAccountName }></IonInput>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <IonLabel>Account Number: </IonLabel>
                                    <IonInput placeholder='Enter Bank Account Number (17 characters max)' maxlength='17' ref={bankAccountNumber }></IonInput>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <IonLabel>Routing Number: </IonLabel>
                                    <IonInput placeholder='Enter Bank Routing Number (9 characters exact)' maxlength='9' ref={routingNumber }></IonInput>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <IonLabel>Bank Name: </IonLabel>
                                    <IonInput placeholder='Enter Bank Name' ref={bankName }></IonInput>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <IonLabel>Branch Name: </IonLabel>
                                    <IonInput placeholder='Enter Bank Branch Name' ref={branchName }></IonInput>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <IonButton onClick={() => handleSavePaymentMethod_checking()}> Save </IonButton>
                                </IonCol>
                                <IonCol>
                                    <IonButton onClick={() => closeModalHandler(false)}> Cancel </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonContent>
                </IonModal>
    )
}